import { algoliasearch } from 'algoliasearch'

const config = {
  appId: process.env.ALGOLIA_APP_ID || '',
  searchKey: process.env.ALGOLIA_KEY || '',
}

const client = algoliasearch(config.appId, config.searchKey)

export default client
